import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismAccordion,
  PrismButton,
  PrismLoadingBar,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import styles from './accordion-year-view.module.css';

export default class GeneralSmartInsightsUpsellAccordionYearView extends Component {
  @service('smart-insights/upsell')
  declare smartInsightsUpsell: Services['smart-insights/upsell'];

  get isPerformancePath(): boolean {
    return this.smartInsightsUpsell.upsellPath === 'performance';
  }

  <template>
    <div
      class={{styles.container}}
      data-test-id="smart-insights-upsell-accordion"
    >
      <PrismAccordion
        @description={{if
          this.smartInsightsUpsell.hasRequestedTrial
          (t "smart_insights.upsell.accordion.thank_you.subtitle")
          (t "smart_insights.upsell.accordion.subtitle")
        }}
        @icon="rocket"
        @title={{if
          this.smartInsightsUpsell.hasRequestedTrial
          (t "smart_insights.upsell.accordion.thank_you.title")
          (t "smart_insights.upsell.accordion.title")
        }}
      >
        <:default>
          {{#if
            (or
              this.smartInsightsUpsell.upsellApiResponseTask.isRunning
              this.smartInsightsUpsell.saveUpsellRecordTask.isRunning
            )
          }}
            <PrismLoadingBar />
          {{/if}}

          {{! Prism's prism-accordion__content already provides 12px padding }}
          <div class="flex flex-col gap-500">
            <p class="text-300--regular text-neutral-emphasis">
              {{#if this.smartInsightsUpsell.hasRequestedTrial}}
                {{t
                  (if
                    this.isPerformancePath
                    "smart_insights.upsell.accordion.thank_you.description.performance"
                    "smart_insights.upsell.accordion.thank_you.description.pricing"
                  )
                }}
              {{else}}
                {{t
                  (if
                    this.isPerformancePath
                    "smart_insights.upsell.accordion.description.performance"
                    "smart_insights.upsell.accordion.description.pricing"
                  )
                }}
              {{/if}}
            </p>

            {{! CTA group: 8px gap between buttons per design }}
            <div class="flex flex-col gap-200">
              {{#unless this.smartInsightsUpsell.hasRequestedTrial}}
                <PrismButton
                  @buttonType="brand"
                  @isDisabled={{this.smartInsightsUpsell.saveUpsellRecordTask.isRunning}}
                  @isLoading={{this.smartInsightsUpsell.saveUpsellRecordTask.isRunning}}
                  @label={{t
                    "smart_insights.upsell.accordion.cta.get_in_touch"
                  }}
                  @onClick={{this.smartInsightsUpsell.onClickGetInTouch}}
                  class="w-full"
                  data-test-id="smart-insights-upsell-get-in-touch"
                />
              {{/unless}}

              <PrismButton
                @buttonType="secondary"
                @label={{if
                  this.isPerformancePath
                  (t "smart_insights.upsell.accordion.cta.explore.performance")
                  (t "smart_insights.upsell.accordion.cta.explore.pricing")
                }}
                @onClick={{this.smartInsightsUpsell.openMarketingPage}}
                class="w-full"
                data-test-id="smart-insights-upsell-explore"
              />
            </div>
          </div>
        </:default>
      </PrismAccordion>
    </div>
  </template>
}
